import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

//  Fallback resources for safety
const fallbackResources = {
  en: {
    translation: {
      appTitle: 'PartsExList',
      accessDenied: 'You do not have permission to view this application.',
      redirecting: 'Redirecting to login...',
      forbiddenMessage: "You don't have permission to access PartsExList. Please contact the admin."
    }
  }
};

i18n
	// .use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		backend: {
			loadPath: function (lng) {
				const currentPath = window.location.pathname;
				let basepath;
				if (currentPath.includes('/home/')) {
					basepath = '/';
				} else if (currentPath.includes('/search-reseller/')) {
					basepath = '/search-reseller';
				} else if (currentPath.includes('/add-new-reseller/')) {
					basepath = '/add-new-reseller';
				} else if (currentPath.includes('/verification-of-reseller/')) {
					basepath = '/verification-of-reseller';
				} else if (currentPath.includes('/edit-reseller/')) {
					basepath = '/edit-reseller';
				} else if (currentPath.includes('/export-data/')) {
					basepath = '/export-data';
				} else if (currentPath.includes('/data-review/')) {
					basepath = '/data-review';
				} else if (currentPath.includes('/maintain-contact-MPC/')) {
					basepath = '/maintain-contact-MPC';
				} else if (currentPath.includes('/maintain-contact/')) {
					basepath = '/maintain-contact';
				} else if (currentPath.includes('/search-contact/')) {
					basepath = '/search-contact';
				} else if (currentPath.includes('/KPI-report/')) {
					basepath = '/KPI-report';
				} else if (currentPath.includes('/download/')) {
					basepath = '';
				} else if (currentPath.includes('/help/')) {
					basepath = '/help';
				} else {
					basepath = '';
				}
				return `${basepath}/locales/${lng}.json`;
			},
		},

		// resources: fallbackResources, //  fallback translations
		fallbackLng: 'English', //  Correct fallback language
		load: 'languageOnly',
		debug: false, // Set true only for debugging
		interpolation: {
		escapeValue: false
		},
		react: {
		useSuspense: false //  Prevent blank screen during loading
		}
	});


export default i18n;
